import React, { Component } from 'react';

const Wifi = ({name, inx}) => <div onClick={global.nextStage}>
	<div style={{
		position:"absolute",
		left: 60,
		top: 220 + inx * 60,
		width:360 - 80,
		height: 2,
		backgroundColor:"black",
		opacity:0.2,
		cursor:"pointer"
	}} />
	<img src={require("./img/openWifi.png")} style={{
				position:"absolute",
				left: 20,
				top: 235 + inx * 60,
				opacity:0.4,
				transform:"scale(0.2)",
				transformOrigin:"top left"
	}}/>
	<div style={{
		position:"absolute",
		left: 70,
		top: 243 + inx * 60,
		width:260,
		height: 50,
	}}>
		<span>{name}</span>
	</div>
</div>
export default class Head extends Component {
	render() {
		return <div style={{}}>
			<div style={{
				position:"absolute",
				left: 0,
				top: 0,
				width:360,
				height:20,
				backgroundColor:global.blue
			}}/>
			<img src={require('./img/wifi.png')} style={{
				position:"absolute",
				left: 20,
				top: 80,
				width:512/17,
				height:398/17
			}} />
			<div style={{
				position:"absolute",
				left: 20,
				top: 140,
				width:360 - 48,
				height:100,
				// backgroundColor:global.blue,
				// display:"flex",
				// justifyContent:"center",
				// alignItems:"center",
				// cursor:"pointer"
			}}>
				<span style={{
					// color:"white"
					fontWeight:"bold"	
				}}>Get Conected</span>
			</div>
			<div style={{
				position:"absolute",
				left: 20,
				top: 170,
				width:360 - 48,
				height:5,
				backgroundColor:global.blue
			}}/>
			<div style={{
				position:"absolute",
				left: 20,
				top: 190,
				width:360 - 48,
				height:100,
				// backgroundColor:global.blue,
				// display:"flex",
				// justifyContent:"center",
				// alignItems:"center",
				// cursor:"pointer"
			}}> 
				<span style={{
					// color:"white"
					// fontWeight:"bold"	
					fontSize:14
				}}>Select Wi-Fi</span>
			</div>
			{["Knut-2.0", "Knut-5.0","Google-guest"].map((_,i) => <Wifi name={_} inx={i} key={i}/>)}
			<div style={{
				position:"absolute",
				left: 60,
				top: 395,
				width:360 - 80,
				height: 2,
				backgroundColor:"black",
				opacity:0.2,
			}} />	
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/Wifi.js